var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 53,
    viewBox: "0 0 61 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_424_11500)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2592 17.5925H22.7777C19.074 17.5925 17.5925 19.0739 17.5925 22.7777V27.2221C17.5925 30.9258 19.074 32.4073 22.7777 32.4073H27.2222C30.9259 32.4073 32.4073 30.9258 32.4073 27.2221V25.7406",
    stroke: "#272727",
    strokeWidth: 1.11111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8432 18.4134L22.7546 23.502C22.5609 23.6958 22.3671 24.0768 22.3284 24.3544L22.0507 26.2982C21.9474 27.0021 22.4446 27.4929 23.1485 27.396L25.0923 27.1183C25.3635 27.0796 25.7445 26.8858 25.9447 26.6921L31.0333 21.6035C31.9116 20.7252 32.3248 19.7049 31.0333 18.4134C29.7418 17.1219 28.7215 17.5351 27.8432 18.4134Z",
    stroke: "#272727",
    strokeWidth: 0.968649,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_424_11500",
    x: 0.111111,
    y: 0.111111,
    width: 60.4444,
    height: 60.4444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.77778,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_424_11500"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.33333,
    dy: 5.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_424_11500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_424_11500",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/New Chat.1874e1957b87615f139aaf6cef4f1854.svg";
export { ForwardRef as ReactComponent };